exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden {\n  display: none;\n}\n@media screen and (min-width: 769px), print {\n.merchant-profile-container .field-label {\n    flex-grow: 2;\n}\n.merchant-profile-container .input-repeater {\n    background: #f0f0f069;\n    border-radius: 5px;\n}\n}", ""]);

// exports
